import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/store/modues/user'
import cart from '@/store/modues/cart'
import address from '@/store/modues/address'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
    token (state) {
      return state.user.userInfo.token
    }
  },
  modules: {
    user,
    cart,
    address
  }
})
